$(function(){
  var header = $('.l-header');
  var mainVisualHeight = $('.p-mainVisual').innerHeight();
  var currentWidth = window.innerWidth;
  var breakpoint_xs = 568;

  //メインヴィジュアルを超えたら
  window.addEventListener('scroll', function() {
    if($(window).scrollTop() >= mainVisualHeight) {
      header.css('background-color', '#fff');
    } else {
      header.css('background-color', 'transparent');
    }
  });

  //はじめての〇〇　スマホスライダー
  firstSlider();
  window.addEventListener('resize', function() {
    if (currentWidth == window.innerWidth) {
      return;
    }
    firstSlider();
    currentWidth = window.innerWidth;
  });

  function firstSlider() {
    currentWidth = window.innerWidth;
    if ( currentWidth <= breakpoint_xs ) {
      $('.p-first__list').not('.slick-initialized').slick({
        responsive: [
          {
            breakpoint: 568,
            settings: {
              autoplay: true,
              centerMode: true,
              infinite: true,
              centerPadding: '60px',
            }
          },
          {
            breakpoint: 9999,
            settings: 'unslick',
          }
        ]
      });
    }
  }

});